import React from 'react';
import {FlexBoxComponent, RichText} from '@gongxigames/framework/core/fragments/react';
import {AutoplayToggleButton, AutoplayToggleButtonProps} from '@gongxigames/framework/slot/modules/autoplayOptions/popup/components/AutoplayToggleButton';

type AutoplayToggleButtonWithTitleProps = Omit<AutoplayToggleButtonProps, 'x' | 'y' | 'name'> & {
    textID: string;
    width: number;
};

export function AutoplayToggleButtonWithTitle(props: AutoplayToggleButtonWithTitleProps): JSX.Element {
    const {onToggle, value, disabled = false, textID, visible = true, width} = props;

    return (
        <FlexBoxComponent name={'AutoplayToggleButtonWithTitle'} gap={80} alignItems={'center'} visible={visible} containerWidth={width}>
            <AutoplayToggleButton disabled={disabled} value={value} onToggle={onToggle}/>
            <RichText id={textID} style={'ErrorPopupTitle'} resolution={1}/>
        </FlexBoxComponent>
    );
}
